import { PropsWithChildren } from 'react';
import { useIdentityContext } from '../store/store';
import { getIdentityConfig } from '../config';

export function UnauthenticatedRoutesGuard({ children }: PropsWithChildren) {
  const user = useIdentityContext((state) => state.user);

  if (user) {
    getIdentityConfig().onAuthenticated();
    return null;
  }

  return children;
}
